import { useEffect, useState } from 'react';
import { paramCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// material
import { Box, Button, Container } from '@mui/material';
// redux
import { useDispatch, useSelector, RootState } from '../../../redux/store';
import { getUserList } from '../../../redux/slices/user';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import { Link as RouterLink, Navigate } from 'react-router-dom';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import { axios } from 'utils/axios';
import TransactionForm from './transactionform/TransactionForm';

// ----------------------------------------------------------------------

export default function AddEditTransaction() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { id = '', clientId } = useParams();
  const isEdit = pathname.includes('edit');
  const isDetails = pathname.includes('details');
  const [transactions, setTransactions] = useState<any>({});

  useEffect(() => {
    if (id) {
      fetchTransactionsById(id);
    }
    if (!isEdit) {
      setTransactions({});
    }
  }, [id, isEdit]);
  const fetchTransactionsById = async (id: any) => {
    const response = await axios.get(`/rest/api/transactions/${id}`);
    setTransactions(response.data.data);
  };

  const handleDownloadPDF = async () => {
    try {
      const response = await axios.get(`/rest/api/transactions/${id}/download-pdf`, {
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `transaction_${id}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error('Error downloading PDF:', error);
      // setSnackbarMessage('Failed to download PDF. Please try again.');
      // setSnackbarOpen(true);
    }
  };
  return (
    <Page title="Contact Site: Create a new contact site">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <HeaderBreadcrumbs
            heading={isEdit ? 'Edit Ticket Transaction' : 'Create Ticket Transaction'}
            links={[
              { name: 'Dashboard', href: '/dashboard' },
              {
                name: 'Ticket Transactions',
                href: '/dashboard/transactions/list'
              },
              { name: isEdit ? 'Edit Ticket Transaction' : 'Create Ticket Transaction' }
            ]}
          />
          {isEdit && (
            <Button
              variant="contained"
              color="secondary"
              size="medium"
              onClick={(event) => {
                event.stopPropagation();
                handleDownloadPDF();
              }}
            >
              Download PDF
            </Button>
          )}
        </Box>

        <TransactionForm isEdit={isEdit} currentTransaction={transactions} />
      </Container>
    </Page>
  );
}
